<template>
    <div class="schedules-calendar-main-container">
        <calendar-date-selector
        :current-date="today"
        :selected-date="selectedDate"
        @dateSelected="selectDate"
        />
        <div class="calendar-month">
            <div class="calendar-table">
                <table class="calendar-table">
                    <calendar-weekdays/>
                    <tbody>
                        <tr v-for="(week, weekIndex) in weeks" :key="weekIndex">
                            <calendar-monthDay-item
                                v-for="day in week"
                                :key="day.date"
                                :day="day"
                                :is-today="day.date === today"
                                :schedules="(typeof dates[day.date] !== 'undefined' ? dates[day.date] : null)"
                                :selected="selected"
                                @select="getSchedule"
                            />
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import CalendarDateSelector from './CalendarDateSelector'
import CalendarWeekdays from './CalendarWeekdays'
import CalendarMonthDayItem from './CalendarMonthDayItem'

dayjs.extend(weekday)
dayjs.extend(weekOfYear)

export default {
  name: 'CalendarMonth',
  props: {
    dates: {
      type: [Array, Object],
      required: false
    },
    selected: {
      type: String,
      required: false
    }
  },
  components: {
    CalendarDateSelector,
    CalendarWeekdays,
    CalendarMonthDayItem
  },
  data () {
    return {
      selectedDate: dayjs()
    }
  },
  computed: {
    days () {
      return [
        ...this.previousMonthDays,
        ...this.currentMonthDays,
        ...this.nextMonthDays
      ]
    },
    weeks () {
      const perChunk = 7 // items per chunk
      const inputArray = this.days
      const result = inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk)
        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [] // start a new chunk
        }
        resultArray[chunkIndex].push(item)
        return resultArray
      }, [])
      return result
    },
    today () {
      return dayjs().format('YYYY-MM-DD')
    },
    month () {
      return Number(this.selectedDate.format('M'))
    },
    year () {
      return Number(this.selectedDate.format('YYYY'))
    },
    numberOfDaysInMonth () {
      return dayjs(this.selectedDate).daysInMonth()
    },
    currentMonthDays () {
      return [...Array(this.numberOfDaysInMonth)].map((day, index) => {
        return {
          date: dayjs(`${this.year}-${this.month}-${index + 1}`).format('YYYY-MM-DD'),
          isCurrentMonth: true
        }
      })
    },
    previousMonthDays () {
      const firstDayOfTheMonthWeekday = this.getWeekday(
        this.currentMonthDays[0].date
      )
      const previousMonth = dayjs(`${this.year}-${this.month}-01`).subtract(1, 'month')
      // Cover first day of the month being sunday (firstDayOfTheMonthWeekday === 0)
      const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday ? firstDayOfTheMonthWeekday - 1 : 6
      const previousMonthLastMondayDayOfMonth = dayjs(this.currentMonthDays[0].date).subtract(visibleNumberOfDaysFromPreviousMonth, 'day').date()
      return [...Array(visibleNumberOfDaysFromPreviousMonth)].map(
        (day, index) => {
          return {
            date: dayjs(`${previousMonth.year()}-${previousMonth.month() + 1}-${previousMonthLastMondayDayOfMonth + index}`).format('YYYY-MM-DD'), isCurrentMonth: false
          }
        }
      )
    },
    nextMonthDays () {
      const lastDayOfTheMonthWeekday = this.getWeekday(
        `${this.year}-${this.month}-${this.currentMonthDays.length}`
      )
      const nextMonth = dayjs(`${this.year}-${this.month}-01`).add(1, 'month')
      const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday ? 7 - lastDayOfTheMonthWeekday : lastDayOfTheMonthWeekday
      return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
        return {
          date: dayjs(
            `${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`
          ).format('YYYY-MM-DD'),
          isCurrentMonth: false
        }
      })
    }
  },
  methods: {
    getWeekday (date) {
      return dayjs(date).weekday()
    },
    selectDate (newSelectedDate) {
      this.selectedDate = newSelectedDate
      this.$emit('dateChange', newSelectedDate.format('YYYY-MM-01'))
    },
    getSchedule (data) {
      this.$emit('select', data)
    }
  }
}
</script>

<style>
</style>
